import { createContext } from "react";
const FontLanguageContext = createContext(null);
export {
  FontLanguageContext
};
//# sourceMappingURL=FontLanguageContext.js.map
